import { customGroupV2 } from "../../basic/path"
import RequestModel from "../../basic/requestConfig"


export default {
    // queryUserGroupInfo(vue, query) {
    //     return new Promise((resolve, reject) => {
    //         let requestModel = new RequestModel({
    //                 method: 'get',
    //                 url: customGroupV2.queryUserGroupInfo,
    //                 data: query.data ? query.data : {},
    //                 params: query.params ? query.params : {}
    //             }),
    //             request = requestModel.defaultConfig();
    //         vue.axios(request).then(function (result) {
    //             resolve(result);
    //         })
    //     });
    // },
    loadCustomSize(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: customGroupV2.loadCustomSize,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    addCustomGroup(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: customGroupV2.addCustomGroup,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
}